export default {
	// 缩放比例 最小兼容1280px宽度屏幕
	scale: 0.0067,
	// api接口
	api: {
		fff: '/apis'
	},
	pathUrl: {
		basePathUrl: process.env.VUE_APP_FLAG == 'prod' ? 'http://syjweb.qiyasoft.top' :  'http://syjweb.qiyasoft.top'
	},
	// cdn资源
	resource: {
		base: process.env.VUE_APP_FLAG == 'prod' ? 'http://syjapi.qiyasoft.top' : 'http://syjapi.qiyasoft.top', // cdn资源地址
	},
	// vue-ls options
	storageOptions: {
		namespace: 'slsz__', // key prefix
		name: 'ls', // name variable Vue.[ls] or this.[$ls],
		storage: 'local', // storage name session, local, memory
	}
}